import { StringUtils } from "@rsm-hcd/javascript-core";
import { HeadingPriority } from "atoms/constants/heading-priority";
import { Icons } from "atoms/constants/icons";
import Heading from "atoms/typography/heading";
import { FileConstants } from "constants/file-constants";
import { siteMap } from "internal-sitemap";
import RemoteAccessDetailsRecord from "models/view-models/remote-access-details-record";
import React from "react";
import useNetworkInformation from "utilities/contexts/network-information/use-network-information";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import FileUtils from "utilities/file-utils";
import { t, tErrorLoading } from "utilities/localization-utils";
import RemoteAccessDetailsService from "utilities/services/remote-access-details-service";
import { ToastManager } from "utilities/toast/toast-manager";
import DashboardLatestNewsItem from "organisms/dashboard-latest-news/dashboard-latest-news-item";

const CSS_BASE_CLASS = "c-dashboard-latest-news";

const DashboardLatestNews = () => {
    const { globalState } = useGlobalState();
    const { isOnline } = useNetworkInformation();
    const { get: getPdf } = RemoteAccessDetailsService.useGetQuery();
    const relativeProviderPath = FileUtils.getLocalizedPath(
        FileConstants.GettingStarted,
        globalState.getPreferredOrCurrentCulture()
    );
    const getPdfEnabled =
        StringUtils.hasValue(relativeProviderPath) && isOnline;

    const getPdfResult = getPdf(
        undefined,
        {
            relativeProviderPath: relativeProviderPath,
        },
        { enabled: getPdfEnabled }
    );
    let remoteAccessDetails = new RemoteAccessDetailsRecord();

    if (getPdfResult.isSuccess) {
        remoteAccessDetails = remoteAccessDetails.with({
            ...getPdfResult.data.resultObject?.toJS(),
        });
    }

    if (getPdfResult.isError) {
        ToastManager.error(
            `${tErrorLoading("resourceType-File")} ${
                FileConstants.GettingStarted
            }`
        );
    }

    return (
        <section className={CSS_BASE_CLASS}>
            <header className={`${CSS_BASE_CLASS}__header`}>
                <Heading
                    cssClassName={`${CSS_BASE_CLASS}__heading`}
                    priority={HeadingPriority.Four}>
                    {t("latestNews")}
                </Heading>
            </header>
            <ul className={`${CSS_BASE_CLASS}__list`}>
                {isOnline && (
                    <React.Fragment>
                        <DashboardLatestNewsItem
                            ariaLabel={t("useNfpaDirect-link-label")}
                            to={siteMap.situationalNavigation.dashboard}
                            iconType={Icons.Sitnav}
                            title={t("useNfpaDirect")}
                        />
                    </React.Fragment>
                )}
                <DashboardLatestNewsItem
                    ariaLabel={t("checkOutFaq-link-label")}
                    to={siteMap.support.faq}
                    iconType={Icons.Question}
                    title={t("checkOutFaq")}
                />
            </ul>
        </section>
    );
};
export default DashboardLatestNews;
